module.exports = __webpack_public_path__ + "img/e_charger_disabled2.08589281.svg";